module.exports = __webpack_public_path__ + "img/cart.43cb806c.png";